/**
 * FS Options
 *
 * Represents a configuration object used to store options for a specific functionality or process.
 * If the variable is uninitialized or falsy, it defaults to an empty object.
 * This ensures that the variable always has a valid object to hold key-value pairs of options.
 */

var __fast_options = __fast_options || {};
__fast_options.disable_ac_shadow_root = true;
__fast_options.with_product_attributes = true;





window.pdpData = {};
window.fsCardProductData = window.fsCardProductData || {};

class FSCustom {

  constructor() {
    this.timeout = null;

    // Set a global variable for login status using Liquid
    this.customerData = {}

    this.fsProductPricing = {};
    this.fetchingSaleTag = false;
  }

  init() {
    let _this = this;

    this.customerData = window.customerData || {};

    this.bindEvents();


    // execution here
    if (window.SerpOptions) {
      _this.plpHooks();
    } else {
      window.addEventListener('fast-serp-ready', function () {
        _this.plpHooks();
      });
    }

    if (window.FastAutocomplete) {
      _this.autocompleteHooks();
    } else {
      window.addEventListener('fast-autocomplete-ready', function () {
        _this.autocompleteHooks();
      });
    }

    if (window.FastRecommendationWidget) {
      _this.upsellHooks();
    } else {
      window.addEventListener('fast-upsell-cross-sell-ready', function () {
        _this.upsellHooks();
      });
    }
  }

  IsUserLoggedin() {
    return Boolean(this.customerData && this.customerData.hasTradePricing);
  }

  isbundled (tags) {
    return tags.includes('Product Bundle');
  }

  bindEvents() {
    let _this = this;
  }

  /**
   * Registers various hooks for updating or modifying the UI elements in specific components such as
   * product grids, top-page options, and product swatches.
   *
   * The hooks manipulate DOM elements to enhance or customize the display and interaction
   * with product reviews, sorting options, and color swatches.
   *
   * The following hooks are registered:
   * - `serp-product-grid`: Enhances product grid items with additional review count and formatting for review averages.
   * - `serp-top-page`: Adds a 'Sort By' label to the sorting dropdown UI if it doesn't already exist.
   * - `serp-product-swatches`: Adds additional functionality and elements to color swatch UI based on the number of available color variations.
   *
   * @return {void} No return value. The function alters DOM elements directly.
   */
  plpHooks() {
    let _this = this;

    window.addEventListener('fs-custom-events-product-swatch-on-click', (e) => {
      setTimeout(() => {
        let pricingData = _this.fsProductPricing[e.detail.parentID];
        if (pricingData) {
          let priceContainer = pricingData.element.querySelector('.price-container.fs-serp-price .price');
          let compareContainer = pricingData.element.querySelector('.compare-container .compare.fs-compare');
          if (priceContainer) {
            priceContainer.innerText = pricingData.price;
          }
          if (compareContainer && pricingData.compareText) {
            compareContainer.innerText = pricingData.compareText;
          }
        }
      }, 5);
    });

    window.SerpOptions.registerHook('serp-main-block', (e) => {

      e.element.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!event.target.classList.contains('monogram-icon-container') && !event.target.closest('.monogram-icon-container')) {
          if (typeof e.element != "undefined" && e.element.querySelector('.monogram-inner-container.active')) {
            _this.clearTooltips(e.element);
          }
        }
      })
    });

    window.SerpOptions.registerHook("serp-product-grid", ({products, element}) => {

      // Loop products
      for (const [productId, product] of Object.entries(products)) {
        let productElement = element.querySelector(`[data-product-id="${productId}"]`);
        if (productElement) {
          _this.updateReviewsCountText(product, productElement);
          _this.addComparePriceToProductBlocks(product, productId, productElement);
          _this.addMonogramIcon(product, productElement);
          _this.addSaleTag(product, productId, productElement);

          // update B2B Prices
          let productURL = product.productURL || '';
          if (!window.pdpData[productId]) {
            window.pdpData[productId] = "notFetched";
          }
          _this.setProductSpecialPrice(productElement, productId, productURL, _this.customerData.tiername);

          // hide promo tiles
          if (document.body.classList.contains('b2b-customer')) {
            element.querySelectorAll('.fs-promo-tile-product-wrapper').forEach(el => {
              el.style.display = 'none';
            });
          }


          // hide products tagged with “Product Bundles”
          if (_this.IsUserLoggedin()) {
            if (_this.isbundled(product.tags || [])) {
              productElement.style.display = 'none';
            }
          }
        }
      }

      _this.updateSearchPageTitle(element);

    });

    window.SerpOptions.registerHook("serp-top-page", ({element}) => {
      setTimeout(() => {
        _this.setupNativeSort(element);
      }, 250);
    });

    window.SerpOptions.registerHook("serp-filters", ({element}) => {
      element.querySelectorAll('.color-swatch-container:not(.ele-bound)').forEach((ele) => {
        ele.addEventListener('click', (e) => {
          if (e.target.classList.contains('color-swatch-container') && !e.target.classList.contains('color-swatch')) {
            if (ele.querySelector('.color-swatch')) {
              ele.querySelector('.color-swatch').click();
            }
          }
        });
        ele.classList.add('ele-bound');
      });

      _this.fixFilterA11y(element);

      _this.a11yFilterContainer = element;
      if (!_this.a11yFilterFocusGuardBound) {
        _this.a11yFilterFocusGuardBound = true;
        document.addEventListener('focusin', (event) => {
          if (_this.isFilterFocusDumpTarget(event.target)) {
            if (!_this.pendingColorFilterFocus && !_this.pendingSortFocus) return;

            window.requestAnimationFrame(() => {
              _this.restorePendingFilterFocus(_this.a11yFilterContainer);
            });
            return;
          }

          _this.clearPendingFilterFocus();
        });
      }

      if (element.a11yFilterObserver) {
        element.a11yFilterObserver.disconnect();
      }

      element.a11yFilterObserver = new MutationObserver(() => {
        _this.fixFilterA11y(element);
      });
      element.a11yFilterObserver.observe(element, {
        attributes: true,
        attributeFilter: ['aria-label', 'aria-checked', 'role', 'tabindex'],
        childList: true,
        subtree: true
      });
    });

    window.SerpOptions.registerHook("serp-product-swatches", ({colors, swatchClick, showMoreClick, element}) => {

      let listEl = element.querySelector('.color-swatches');

      if (colors.length > 6 && !listEl.querySelector('.color-swatch-extra-colors')) {
        let extraColorsLength = colors.length - 6;
        let extraColorsText = extraColorsLength === 1 ? 'color' : 'colors';
        let text = `+ ${extraColorsLength} ${extraColorsText}`;

        let link = element.closest('.product-card').querySelector('.title-container').getAttribute('href');

        let colorsCountEl = document.createElement("a");
        colorsCountEl.classList.add('color-swatch-extra-colors');
        colorsCountEl.innerText = text;
        colorsCountEl.setAttribute('href', link);
        colorsCountEl.setAttribute('tabindex', '0');
        colorsCountEl.setAttribute('role', 'button');
        colorsCountEl.setAttribute('aria-label', text);
        listEl.appendChild(colorsCountEl);
      }

      setTimeout(function () {
        if (colors.length === 1 && listEl.querySelectorAll('.color-swatch-container').length < 1) {

          let resultClass = '';
          let randomSwatchEl = element.closest('.searchResultsWrapper').querySelector('.color-swatch');

          if (randomSwatchEl) {
            randomSwatchEl.classList.forEach((className) => {
              if (className.indexOf('fs-result-page-') > -1) {
                resultClass = className;
              }
            });
          }

          let color = colors[0];
          let swatchContainer = document.createElement("span");
          swatchContainer.classList.add('color-swatch-container');
          swatchContainer.classList.add('fs-color-swatch-container');
          swatchContainer.setAttribute('tabindex', '0');
          swatchContainer.setAttribute('role', 'button');
          swatchContainer.setAttribute('aria-label', `; Variant: ${color.value}`);

          let colorHandle = color.value.toLowerCase().replace(/\s/g, '-');

          let swatchElement = document.createElement("span");
          swatchElement.classList.add('color-swatch');
          swatchElement.classList.add('fast-swatch-color-fallback');
          swatchElement.classList.add(`fast-swatch-color-${colorHandle}`);
          swatchElement.classList.add(`isp-product-color-swatch-${colorHandle}`);
          if (resultClass) {
            swatchElement.classList.add(resultClass);
          }
          swatchElement.setAttribute('data-disabled', 'false');
          swatchElement.setAttribute('style', '--swatch-width:25px;--swatch-height:25px');
          //swatchElement.setAttribute('title', color.value);
          swatchElement.addEventListener('click', swatchClick);

          swatchContainer.appendChild(swatchElement);
          listEl.appendChild(swatchContainer);
        }
      }, 1)
    });

  }

  isFilterFocusDumpTarget(element) {
    if (!element || !element.isConnected) return true;
    if (element === document.body || element === document.documentElement) return true;
    return element.id === 'fast-simon-serp-app';
  }

  clearPendingFilterFocus() {
    this.pendingColorFilterFocus = null;
    this.pendingSortFocus = null;
    window.clearTimeout(this.colorFilterFocusCleanupTimeout);
    window.clearTimeout(this.sortFocusCleanupTimeout);
    window.clearTimeout(this.colorFilterFocusRestoreTimeout);
    window.clearTimeout(this.sortFocusRestoreTimeout);
  }

  getPendingFilterFocusTarget(container) {
    const search = (root) => {
      if (!root) return null;

      if (this.pendingColorFilterFocus) {
        return Array.from(root.querySelectorAll('.fs-a11y-color-filter')).find(
          (input) => input.getAttribute('aria-label') === this.pendingColorFilterFocus
        ) || null;
      }

      if (this.pendingSortFocus) {
        return Array.from(root.querySelectorAll('.fs-native-sort-select')).find((select) =>
          Array.from(select.options).some((option) => option.textContent.trim() === this.pendingSortFocus)
        ) || null;
      }

      return null;
    };

    return search(container) || search(document);
  }

  // The mobile filter modal renders in Fast Simon's own portal shadow root, which
  // never gets fast-simon-custom-css, so the filter a11y styles are added to each root.
  ensureFilterA11yStyles(root) {
    if (!root || root.querySelector('#fs-a11y-filter-styles')) return;

    const style = document.createElement('style');
    style.id = 'fs-a11y-filter-styles';
    style.textContent = `
      .color-swatch-container { position: relative; }
      .fs-a11y-color-filter {
        position: absolute;
        z-index: 1;
        width: 20px;
        height: 20px;
        margin: 0;
        opacity: 0;
        cursor: pointer;
      }
      .fs-a11y-color-filter:focus-visible + .color-swatch {
        outline: 2px solid #212121;
        outline-offset: 2px;
      }
      /* Collapsed filter groups only shrink to max-height: 0, which leaves their
         options in the tab order while hidden. */
      .category-items.collapsed {
        visibility: hidden;
      }
    `;
    (root.head || root).appendChild(style);
  }

  restorePendingFilterFocus(container) {
    if (!this.pendingColorFilterFocus && !this.pendingSortFocus) return;
    if (!this.isFilterFocusDumpTarget(document.activeElement)) return;

    const focusTarget = this.getPendingFilterFocusTarget(container);
    if (!focusTarget) return;

    focusTarget.focus();
    this.clearPendingFilterFocus();
  }

  setupNativeSort(container) {
    const wrapper = container.querySelector('.fs-select-wrapper');
    const customSelect = wrapper && wrapper.querySelector('.select');
    const customOptions = customSelect && Array.from(customSelect.querySelectorAll('.custom-option'));

    if (!wrapper || !customSelect || !customOptions.length) {
      return;
    }

    let select = wrapper.querySelector('.fs-native-sort-select');
    let label = wrapper.querySelector('label.fs-select-label');

    wrapper.querySelectorAll('.fs-select-label:not(label)').forEach((existingLabel) => {
      existingLabel.remove();
    });

    if (!select) {
      select = document.createElement('select');
      select.id = `fs-sort-${Math.random().toString(36).slice(2, 9)}`;
      select.classList.add('fs-native-sort-select');
      select.addEventListener('click', (event) => {
        event.stopPropagation();
      });
      select.addEventListener('keydown', (event) => {
        event.stopPropagation();

        const lastIndex = select.options.length - 1;
        let nextIndex = select.selectedIndex;

        if (event.key === 'ArrowDown') nextIndex = Math.min(select.selectedIndex + 1, lastIndex);
        else if (event.key === 'ArrowUp') nextIndex = Math.max(select.selectedIndex - 1, 0);
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = lastIndex;
        else if (event.key === 'Enter') {
          event.preventDefault();
          return;
        } else {
          return;
        }

        event.preventDefault();
        if (nextIndex !== select.selectedIndex) {
          select.selectedIndex = nextIndex;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (!label) {
      label = document.createElement('label');
      label.classList.add('fs-select-label');
      label.textContent = 'Sort By:';
    }
    label.htmlFor = select.id;

    select.replaceChildren();
    customOptions.forEach((customOption, index) => {
      const option = document.createElement('option');
      option.value = String(index);
      option.textContent = customOption.textContent.trim();
      option.selected = customOption.classList.contains('selected');
      select.appendChild(option);
    });

    select.onchange = () => {
      const selectedOption = Array.from(customSelect.querySelectorAll('.custom-option'))[select.selectedIndex];
      if (selectedOption) {
        this.pendingSortFocus = selectedOption.textContent.trim();
        window.clearTimeout(this.sortFocusCleanupTimeout);
        this.sortFocusCleanupTimeout = window.setTimeout(() => {
          this.pendingSortFocus = null;
        }, 2000);
        selectedOption.click();
      }
    };

    wrapper.removeAttribute('role');
    wrapper.removeAttribute('tabindex');
    wrapper.removeAttribute('aria-haspopup');
    wrapper.removeAttribute('aria-label');
    wrapper.removeAttribute('aria-expanded');
    wrapper.removeAttribute('aria-controls');
    wrapper.removeAttribute('aria-activedescendant');

    customSelect.setAttribute('aria-hidden', 'true');
    customSelect.classList.add('fs-custom-select--a11y-hidden');
    wrapper.append(label, select);

    if (this.pendingSortFocus) {
      window.clearTimeout(this.sortFocusRestoreTimeout);
      this.sortFocusRestoreTimeout = window.setTimeout(() => {
        this.restorePendingFilterFocus(container);
      }, 250);
    }

    if (wrapper.a11ySortObserver) {
      wrapper.a11ySortObserver.disconnect();
    }
    wrapper.a11ySortObserver = new MutationObserver(() => {
      this.setupNativeSort(container);
    });
    wrapper.a11ySortObserver.observe(customSelect, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

  fixFilterA11y(container) {
    this.ensureFilterA11yStyles(container.getRootNode ? container.getRootNode() : document);

    container.querySelectorAll('.swatches').forEach((swatchGroup) => {
      swatchGroup.removeAttribute('role');
      swatchGroup.removeAttribute('tabindex');
      swatchGroup.removeAttribute('aria-label');
    });

    container.querySelectorAll('.checkbox:not(input)').forEach((checkbox) => {
      const input = checkbox.querySelector('input[type="checkbox"], input[type="radio"]');
      const visualText = checkbox.querySelector('.filters-option-text');

      checkbox.removeAttribute('role');
      checkbox.removeAttribute('tabindex');
      checkbox.removeAttribute('aria-checked');

      if (!input) {
        return;
      }

      if (!input.id) {
        input.id = `fs-filter-${Math.random().toString(36).slice(2, 9)}`;
      }

      const inputLabel = visualText
        ? visualText.textContent.trim()
        : (input.getAttribute('aria-label') || 'Filter option');
      const generatedLabel = checkbox.querySelector('.fs-a11y-filter-label');

      if (generatedLabel) {
        generatedLabel.remove();
      }

      input.removeAttribute('tabindex');

      if (visualText) {
        if (!visualText.id) {
          visualText.id = `fs-filter-label-${Math.random().toString(36).slice(2, 9)}`;
        }

        input.setAttribute('aria-labelledby', visualText.id);
        input.removeAttribute('aria-label');
        visualText.removeAttribute('role');
        visualText.removeAttribute('tabindex');
        visualText.removeAttribute('aria-label');
      } else {
        input.removeAttribute('aria-labelledby');
        input.setAttribute('aria-label', inputLabel);
      }
    });

    container.querySelectorAll('.color-swatch-container').forEach((swatchContainer) => {
      const swatch = swatchContainer.querySelector('.color-swatch');
      const colorNameElement = swatchContainer.querySelector('.color-swatch-color-name');
      const colorName = colorNameElement?.textContent.trim();

      if (!swatch) return;

      swatchContainer.removeAttribute('role');
      swatchContainer.removeAttribute('tabindex');
      swatchContainer.removeAttribute('aria-label');
      swatchContainer.removeAttribute('aria-checked');
      swatch.removeAttribute('role');
      swatch.removeAttribute('tabindex');
      swatch.removeAttribute('aria-label');
      swatch.removeAttribute('aria-checked');
      colorNameElement?.removeAttribute('role');
      colorNameElement?.removeAttribute('tabindex');
      colorNameElement?.removeAttribute('aria-label');
      colorNameElement?.removeAttribute('aria-checked');

      let input = swatchContainer.querySelector('.fs-a11y-color-filter');
      if (!input) {
        input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'fs-a11y-color-filter';
        input.id = `fs-color-filter-${Math.random().toString(36).slice(2, 9)}`;
        input.addEventListener('change', (event) => {
          const currentInput = event.currentTarget;
          const currentSwatch = currentInput.parentElement?.querySelector('.color-swatch');
          this.pendingColorFilterFocus = currentInput.getAttribute('aria-label');
          window.clearTimeout(this.colorFilterFocusCleanupTimeout);
          this.colorFilterFocusCleanupTimeout = window.setTimeout(() => {
            this.pendingColorFilterFocus = null;
          }, 2000);
          currentSwatch?.click();
          window.requestAnimationFrame(() => {
            currentInput.checked = currentSwatch?.classList.contains('selected') || false;
          });
        });
        swatch.before(input);
      }

      this.ensureFilterA11yStyles(input.getRootNode());
      input.checked = swatch.classList.contains('selected');

      const inputLabel = colorName ? `Filter by color ${colorName}` : 'Filter by color';
      if (input.getAttribute('aria-label') !== inputLabel) {
        input.setAttribute('aria-label', inputLabel);
      }

      if (input.a11yColorSwatch !== swatch) {
        input.a11yColorObserver?.disconnect();
        input.a11yColorSwatch = swatch;
        input.a11yColorObserver = new MutationObserver(() => {
          input.checked = swatch.classList.contains('selected');
        });
        input.a11yColorObserver.observe(swatch, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    });

    if (this.pendingColorFilterFocus) {
      window.clearTimeout(this.colorFilterFocusRestoreTimeout);
      this.colorFilterFocusRestoreTimeout = window.setTimeout(() => {
        this.restorePendingFilterFocus(container);
      }, 250);
    }
  }

  /**
   * Registers a hook to customize the rendering of autocomplete product items.
   * This method modifies the product item's HTML by injecting additional review and rating data.
   * The function initializes elements needed for displaying Yotpo reviews and processes them asynchronously.
   *
   * @return {void} This function does not return any value.
   */
  autocompleteHooks() {
    let _this = this;

    window.FastAutocomplete.registerHook('render-autocomplete-product-item', ({product, index, element}) => {

      // hide products tagged with “Product Bundles”
      if (_this.IsUserLoggedin()) {
        var tags=[];
        if(product.att.find(a=>a[0]=="Tag"))
        {
          tags = product.att.find(a=>a[0]=="Tag")[1]
        }

        if (_this.isbundled(product.tags || tags)) {
          element.style.display = 'none';
        }
      }

      if(document.body.dataset.priceRangesInAutocomplete && document.body.dataset.priceRangesInAutocomplete === "true") {
        if (product.p_max && product.p_min && product.p_max !== product.p_min) {
          const priceWrapper = element.querySelector('.price.fs-product-price-wrapper');
          if (priceWrapper) {
            const actualPriceSpan = priceWrapper.querySelector('.actual-price');
            const comparePriceSpan = priceWrapper.querySelector('.compare');

            // Update the main price to show a range.
            if (actualPriceSpan) {
              const priceRangeText = `$${product.p_min} - $${product.p_max}`;
              actualPriceSpan.innerText = priceRangeText;
              actualPriceSpan.setAttribute('aria-label', `; price: ${priceRangeText}`);
            }

            // If a compare-at price exists, update it to show a range as well.
            if (comparePriceSpan) {
              // Determine the correct min and max compare-at prices based on conditions.
              const minCompare = (parseFloat(product.p_min_c) <= 0 || parseFloat(product.p_min_c) < parseFloat(product.p_min))
                  ? product.p_min
                  : product.p_min_c;

              const maxCompare = (parseFloat(product.p_max_c) <= 0 || parseFloat(product.p_max_c) < parseFloat(product.p_max))
                  ? product.p_max
                  : product.p_max_c;

              const comparePriceRangeText = `$${minCompare} - $${maxCompare}`;
              comparePriceSpan.innerText = comparePriceRangeText;
              comparePriceSpan.setAttribute('aria-label', `; price: ${comparePriceRangeText}`);
            }
          }
        }
      }

      if (product.hasOwnProperty('reviews_count') && product.reviews_count > 0) {
        if (element.querySelector('.yotpo')) {
          element.querySelector('.yotpo').remove();
        }
        if (element.querySelector('.yotpo-widget-instance')) {
          element.querySelector('.yotpo-widget-instance').remove();
        }
        let reviews = document.createElement('div');
        reviews.classList.add('yotpo');
        reviews.classList.add('bottomLine');
        reviews.dataset.productId = product.id;
        reviews.dataset.url = product.u;

        element.querySelector('.info').insertBefore(reviews, element.querySelector('.fs-product-title'));
        if (typeof yotpoWidgetsContainer != "undefined" && !element.querySelector('.yotpo-widget-instance')) {
          yotpoWidgetsContainer.initWidgets();
        }
        // Add observer for .info element modifications
        let infoElement = element.querySelector('.info');
        if (infoElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList' || mutation.type === 'subtree') {
                let bottomLineText = infoElement.querySelector('.yotpo-sr-bottom-line-text');
                if (bottomLineText) {
                  let text = bottomLineText.innerText.replace(' Reviews', '').trim();
                  if (!text.includes('(')) {
                    bottomLineText.innerHTML = '(' + text + ')';
                  }
                }
              }
            });
          });

          observer.observe(infoElement, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
      }

    });
  }

  /**
   * Registers hooks to manipulate upsell and cross-sell product display logic.
   * This method customizes the display of product variants, such as colors and sizes,
   * in the FastRecommendationWidget's upsell or cross-sell product widgets.
   *
   * Product swatches or dropdown selectors are dynamically created and appended
   * based on the available variants of each product. The method also rebinds
   * event listeners for "add to cart" buttons to handle variant-specific actions.
   *
   * @return {void} This method does not return any value.
   */
  upsellHooks() {
    let _this = this;

    window.FastRecommendationWidget.registerHook('upsell-cross-sell-products', ({products, element}) => {
      const isPdpWidget = _this.isPdpUpsellWidget(element);

      if (isPdpWidget) {
        _this.updatePDPWidgetTitle(element);
        _this.bindUpsellCarouselDrag(element);
      }

      Object.entries(products || {}).forEach(([productId, product]) => {
        try {
          const productElement = _this.getUpsellProductElement(element, product, productId);
          if (!productElement) return;

          if (isPdpWidget) {
            _this.formatUpsellReviews(product, productElement);
            _this.applyUpsellPriceRange(product, productElement);
            _this.layoutUpsellCard(productElement);
            _this.moveUpsellBadgesToImage(productElement);
          }

          _this.normalizeUpsellSwatches(product, productElement);

          const target = productElement.querySelector('.add-to-cart-button-wrapper');
          if (target && !target.querySelector('.size-select')) {
            _this.addVariantSelectToUpsellCard(product, target);
          }

          if (isPdpWidget) {
            if (product.productURL) productElement.dataset.fsProductUrl = product.productURL;
            if (product.u) productElement.dataset.fsProductUrl = product.u;
            if (product.url) productElement.dataset.fsProductUrl = productElement.dataset.fsProductUrl || product.url;
            if (product.handle) productElement.dataset.fsProductHandle = product.handle;
            _this.bindUpsellCardPrice(productElement);
            _this.hydrateUpsellCardVariants(product, productElement);
            if (productElement.dataset.fsPriceSelected === 'true') {
              _this.updateUpsellSelectedPrice(productElement);
              _this.syncUpsellAvailability(productElement);
            }
          }
        } catch (err) {
          return;
        }
      });
    });
  }

  /**
   * Handles the "add to cart" (ATC) click on an upsell product.
   * Prevents default event behavior, retrieves the clicked variant, and attempts to add it to the cart.
   * Updates the cart UI if applicable or reloads the page if required.
   *
   * @param {Event} e - The event object from the upsell add-to-cart button click.
   * @return {void} This method does not return any value.
   */
  handleUpsellATCClick(e) {
    let _this = this;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    let variant = _this.getUpsellClickedVariant(e.target);
    if (variant && variant.available === false) return;
    if (typeof variant !== 'undefined' && typeof variant.id !== 'undefined') {
      _this.addToCart({
        id: variant.id,
        quantity: 1
      }).then((response) => {

          document.dispatchEvent(new CustomEvent('cart:updated', {detail: response}));

          // If GWP is enabled let it handle the cart update, otherwise handle it here
          if(typeof window.gwpEnabled == "undefined" || !window.gwpEnabled) {
            var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cart && typeof cart.renderContents === 'function' && !document.querySelector('body').classList.contains('template--cart')) {
              cart.renderContents(response.cart);
            } else {
              // If cart element doesn't exist or doesn't have renderContents, reload the page
              location.reload();
            }
          }

        });
    }

  }

  /**
   * Retrieves the clicked upsell variant from a given button.
   *
   * Matches on the selected colour swatch as well as the selected size so the plus button adds
   * the variant the shopper is looking at. Falls back to a size only match when the card has no
   * swatch selection, such as a single option product.
   *
   * @param {Element} btn - The button element that triggered the event.
   * @return {Object|undefined} The matching variant object if available; otherwise, undefined.
   */
  getUpsellClickedVariant(btn) {
    if (!btn.classList.contains('add-to-cart-button')) {
      btn = btn.closest('.add-to-cart-button');
    }

    let variants = btn.closest('.add-to-cart-button-wrapper').dataset.variants;
    if (typeof variants.length > 0 != "undefined") variants = JSON.parse(variants);

    let targetSelect = btn.closest('.button-wrapper').querySelector('.size-select');
    let selectedSize = targetSelect.value;

    let selectedColor = this.getUpsellSelectedColor(btn);
    if (selectedColor) {
      return variants.find(variant => {
        return variant.size === selectedSize && this.toUpsellColorHandle(variant.color) === selectedColor;
      });
    }

    return variants.find(variant => variant.size === selectedSize);
  }

  /**
   * Normalises a colour name so swatch markup and variant data can be compared.
   *
   * @param {string} name - The raw colour name.
   * @return {string} The lowercased, dash separated handle.
   */
  toUpsellColorHandle(name) {
    return String(name || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
  }

  /**
   * Reads the colour of the currently selected swatch on the card the given button belongs to.
   *
   * @param {Element} btn - The add to cart button inside the product card.
   * @return {string} The normalised colour handle, or an empty string when nothing is selected.
   */
  getUpsellSelectedColor(btn) {
    const card = btn && (btn.closest('.fs-upsell-cross-sell-product, .fs-recommendation-product-container, .product-card') ||
      (btn.classList && (btn.classList.contains('fs-recommendation-product-container') || btn.classList.contains('fs-upsell-cross-sell-product')) ? btn : null));
    if (!card) return '';

    const swatch = card.querySelector('.color-swatch.selected') ||
      card.querySelector('.color-swatch-container.selected .color-swatch');
    if (!swatch) return '';

    const fromName = this.getUpsellSwatchColor(swatch);
    if (fromName) return fromName;

    const labelled = swatch.closest('[aria-label]');
    const fromLabel = labelled ? (labelled.getAttribute('aria-label').split('Variant:')[1] || '') : '';
    return this.toUpsellColorHandle(fromLabel);
  }

  /**
   * Updates the search page title with the search query if applicable. Also adjusts the product grid layout.
   *
   * @param {HTMLElement} element The HTML element from which the closest `.searchResultsWrapper` is determined.
   * @return {void} This method does not return any value.
   */
  updateSearchPageTitle(element) {
    // Update the search page title text
    let searchWrapper = element.closest('.searchResultsWrapper');
    if (searchWrapper) {
      let title = searchWrapper.querySelector('.titleWrapper .title');
      // Only do this once - if the title is already updated, don't do anything.
      if (title && title.innerText.toLowerCase().trim().includes('search results for')) {
        const url = new URL(window.location.href);
        const searchQuery = url.searchParams.get('q');
        if (searchQuery) {
          title.innerText = `Search Results for "${searchQuery}"`;
        }
        title.closest('.titleWrapper').classList.add('show');
        let productGrid = searchWrapper.querySelector('.products-grid');
        if (productGrid) {
          productGrid.style.setProperty("--grid-template-columns", "repeat(4, 1fr)");
        }
      }
    }
  }

  /**
   * Updates the reviews count text for a product.
   *
   * @param {Object} product - The product object containing review information.
   * @param {number} product.reviewCount - The number of reviews for the product.
   * @param {HTMLElement} productElement - The DOM element representing the product.
   * @return {void} This method does not return any value.
   */
  updateReviewsCountText(product, productElement) {
    // Update the reviews count text
    if (product.hasOwnProperty('reviewCount') && product.reviewCount > 0) {
      let reviewAvgEl = productElement.querySelector('.fs-reviews-avg');
      if (reviewAvgEl && !reviewAvgEl.innerText.includes('(')) {
        reviewAvgEl.innerHTML = `<span class="fs-reviews-avg-el">(${reviewAvgEl.innerText})</span>`;
      }
      let reviewCountEl = productElement.querySelector('.fs-reviews-count');
      if (reviewCountEl && !reviewCountEl.innerText.includes('reviews')) {
        reviewCountEl.innerText = reviewCountEl.innerText.replace('(', '').replace(')', '') + ' reviews';
      }
    }
  }

  /**
   * Adds a compare price element to the product blocks on the page, handling the creation of necessary DOM elements
   * and updating pricing details in the global `fsProductPricing` object.
   *
   * @param {Object} product - An object containing product details such as the formatted price and compare price.
   * @param {string} productId - The unique identifier for the product to be updated.
   * @param {HTMLElement} productElement - The DOM element representing the product block on the page.
   * @return {void} This method does not return a value.
   */
  addComparePriceToProductBlocks(product, productId, productElement) {
    let _this = this;

    let b2bMultiplier = 1;
    if (typeof window.b2bMultiplier != 'undefined') {
      b2bMultiplier = parseFloat(window.b2bMultiplier);
    }

    // Add the compare price to product blocks if applicable
    if (typeof _this.fsProductPricing == "undefined" || !_this.fsProductPricing) {
      _this.fsProductPricing = {};
    }
    _this.fsProductPricing[`${productId}`] = {price: product.formattedPrice, element: productElement};
    if (!productElement.querySelector('.price-holder')) {
      let priceContainer = productElement.querySelector('.price-container.fs-serp-price');
      let compareContainer = productElement.querySelector('.compare-container');
      if (priceContainer) {
        let priceHolder = document.createElement("div");
        priceHolder.classList.add('price-holder');
        priceContainer.parentNode.insertBefore(priceHolder, priceContainer);
        priceHolder.appendChild(priceContainer);
        if (compareContainer) {
          priceHolder.appendChild(compareContainer);
        }
      }
    }
    let compareEl = productElement.querySelector('.compare.fs-compare');
    if (compareEl) {
      let comparePrice = `$${product.comparePrice * b2bMultiplier}`;
      let maxComparePrice = `$${product.maxCompare * b2bMultiplier}`;
      compareEl.innerText = comparePrice;
      if (maxComparePrice && product.maxCompare > 0 && maxComparePrice !== comparePrice) {
        compareEl.innerText += ` - ${maxComparePrice}`;
      }
      _this.fsProductPricing[`${productId}`].compareText = compareEl.innerText;
    }
  }

  /**
   * Adds a monogram icon to the specified product element if the product matches the monogram tag set in the global window object.
   * The monogram icon will display a tooltip when clicked, showing additional descriptive text defined in the global configuration.
   *
   * @param {Object} product - The product object to check for matching tags.
   * @param {HTMLElement} productElement - The HTML element associated with the product where the icon will be added.
   * @return {void} No value is returned. The function modifies the DOM to add the monogram icon if conditions are met.
   */
  addMonogramIcon(product, productElement) {
    if (typeof window.productMonogramTag != "undefined" &&
      typeof window.productMonogramIcon != "undefined") {

      let iconHoverText = window.productMonogramIconHoverText;

      let hasTag = product?.tags?.find(tag => {
        return tag.toLowerCase() === window.productMonogramTag.toLowerCase();
      })

      if (hasTag) {
        let target = productElement.querySelector('.info-container .price-holder');

        if (target && !target.querySelector('.monogram-icon')) {
          let titlewrapper = productElement.querySelector('.info-container .fs-product-title-wrapper');

          let iconContainer = document.createElement('div');
          iconContainer.classList.add('monogram-icon-container');

          iconContainer.innerHTML = `<div class="monogram-inner-container">
            <span class="monogram-tooltip-trigger"  tabindex="0">
                <img class="monogram-icon" src="${window.productMonogramIcon}" aria-hidden="true"/>
                <span class="visually-hidden">Item can be personalized.</span>
            </span>
            <div class="monogram-tooltip" role="tooltip">${iconHoverText}</div>
            </div>`

          let icon = iconContainer.querySelector('.monogram-tooltip-trigger');
          icon.addEventListener('click', (e) => {
            let tooltipContainer = icon.closest('.monogram-inner-container');

            if (tooltipContainer) {
              tooltipContainer.classList.toggle('active');
            }
          });
          icon.addEventListener('keydown', (e) => {
            const selectedKey = e.keyCode || e.which;
            if([13,32].includes(selectedKey)){
                e.preventDefault();
                e.stopPropagation();

                let tooltipContainer = icon.closest('.monogram-inner-container');

                if (tooltipContainer) {
                tooltipContainer.classList.toggle('active');
                }
            }
          });

          target.appendChild(iconContainer);
          titlewrapper.classList.add('has-monogram');

          setTimeout(() => {
            let titleHeight = titlewrapper.offsetHeight;
            productElement.querySelector('.monogram-icon-container').style.setProperty('top', `-${titleHeight}px`);
          }, 1);
        }
      }
    }
  }

  /**
   * Retrieves an array of section configurations to render on the UI.
   *
   * @return {Array<Object>} An array of objects, where each object represents a section with details like id, optional section name, and optional selector for targeting specific elements.
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: '#cart-notification-all-products',
      },
      // {
      //   id: 'cart-notification-product',
      //   selector: [id="cart-notification-product-${this.cartItemKey}"],
      // },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble'
      },
      {
        id: 'cart-sub-total',
        section: 'cart-sub-total'
      }
    ];
  }

  /**
   * Adds an item to the cart.
   *
   * @param {Object} item - The item to be added to the cart. Typically contains details such as the product ID, quantity, etc.
   * @param {Object} [extras={}] - Optional additional details to include with the cart item.
   * @return {Promise<Object>} Resolves with an object containing the status, message, and updated cart data if successful. Rejects with an object containing the error status, message, and variant ID if the operation fails.
   */
  addToCart(item, extras = {}) {
    let _this = this;
    return new Promise(async (resolve, reject) => {

      let sections = {sections: _this.getSectionsToRender().map((section) => section.section).filter(Boolean)};

      const cartResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({...item, ...extras, ...sections}),
      });

      if (cartResponse.ok) {
        resolve({
          status: 200,
          message: 'Item added to cart.',
          cart: await cartResponse.json()
        });
        return;
      }

      reject({
        status: cartResponse.status,
        message: cartResponse.statusText,
        variant_id: item.id,
      });
    });
  }

  /**
   * Updates the title of a PDP (Product Detail Page) widget if applicable.
   * Replaces the widget's title based on the globally defined title `window.pdp_recommendations_title`.
   *
   * @param {HTMLElement} element - The DOM element within the widget that triggers the title update logic.
   * @return {void} - Does not return anything.
   */
  isPdpUpsellWidget(element) {
    const widgetId = '17561415734407537';
    if (!element) return false;

    if (typeof element.closest === 'function') {
      if (element.closest(`#fast-simon-new-upsell-${widgetId}, .fast-simon-new-upsell-${widgetId}`)) {
        return true;
      }
    }

    const host = element.getRootNode && element.getRootNode().host;
    if (host && (
      host.id === `fast-simon-new-upsell-${widgetId}` ||
      (host.classList && host.classList.contains(`fast-simon-new-upsell-${widgetId}`))
    )) {
      return true;
    }

    return element.id === `fast-simon-new-upsell-${widgetId}` ||
      (element.classList && element.classList.contains(`fast-simon-new-upsell-${widgetId}`));
  }

  /**
   * Finds the element that wraps the carousel track for a recommendation widget.
   *
   * @param {HTMLElement} element - Any element inside the widget.
   * @return {?HTMLElement} The carousel root, or null when the widget is not a carousel.
   */
  getUpsellCarouselRoot(element) {
    if (!element) return null;

    if (typeof element.closest === 'function') {
      const inside = element.closest('.carousel-container, #carousel');
      if (inside) return inside;
    }

    const scope = (typeof element.closest === 'function' &&
      element.closest('.widget-main, .fs-recommendation-widget-container')) || element;

    return scope.querySelector('.carousel-container') ||
      scope.querySelector('#carousel') ||
      scope.querySelector('.fs-recommendation-widget-products-container') ||
      scope.querySelector('.upsell-cross-sell-product-grid');
  }

  /**
   * Returns the control that moves the carousel one slide in the given direction.
   * Prefers Fast Simon's own arrow buttons and falls back to its pagination dots,
   * since the arrows are not rendered for every widget layout.
   *
   * @param {HTMLElement} root - The carousel root.
   * @param {string} direction - Either 'next' or 'previous'.
   * @return {?HTMLElement} The control to click, or null when there is nothing to move to.
   */
  getUpsellCarouselControl(root, direction) {
    const scope = root.closest('.widget-main, .fs-recommendation-widget-container') || root.parentElement || root;
    const label = direction === 'next' ? 'Next Slide' : 'Previous Slide';

    const arrow = scope.querySelector(`.fs-recommendation-button[aria-label="${label}"]`) ||
      scope.querySelector(`[aria-label="${label}"]`);
    if (arrow && !arrow.disabled) return arrow;

    // Dots fallback: the active dot is the one Fast Simon renders with an empty fill.
    const dots = Array.from(scope.querySelectorAll('.dotsContainer .dot'));
    if (!dots.length) return null;

    const active = dots.findIndex((dot) => dot.querySelector('svg[fill=""]'));
    if (active < 0) return null;

    return dots[direction === 'next' ? active + 1 : active - 1] || null;
  }

  /**
   * Adds drag and swipe navigation to the PDP recommendation carousel.
   *
   * Fast Simon only ships arrow and dot navigation, so a horizontal drag (touch, pen or mouse) is
   * translated into a click on its own controls. Driving Fast Simon's controls rather than moving
   * the track ourselves keeps its transition and slide bookkeeping intact, and gives the carousel
   * the same drag behaviour as the native featured products slider.
   *
   * @param {HTMLElement} element - Any element inside the widget.
   * @return {void}
   */
  bindUpsellCarouselDrag(element) {
    const root = this.getUpsellCarouselRoot(element);
    if (!root || root.dataset.fsDragBound === 'true') return;
    root.dataset.fsDragBound = 'true';

    const threshold = 40;
    const controls = 'select, button, input, a[href], .add-to-cart-button, .color-swatch, .color-swatch-container, .fs-recommendation-button, .classic-quick-view-container, .dotsContainer';

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let dragged = false;
    let handled = false;

    const reset = () => {
      pointerId = null;
      handled = false;
    };

    root.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Leave the card's own controls alone so selects and buttons keep working.
      if (e.target.closest && e.target.closest(controls)) return reset();

      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      dragged = false;
      handled = false;
    });

    root.addEventListener('pointermove', (e) => {
      if (pointerId === null || e.pointerId !== pointerId || handled) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (Math.abs(dx) > 5) dragged = true;

      // Fast Simon already swipes on touch. Clicking its arrows too skips two slides.
      if (e.pointerType !== 'mouse') return;

      // A mostly vertical gesture belongs to the page, so it can keep scrolling.
      if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy)) return;

      const control = this.getUpsellCarouselControl(root, dx < 0 ? 'next' : 'previous');
      if (control) control.click();
      handled = true;
    });

    root.addEventListener('pointerup', reset);
    root.addEventListener('pointercancel', reset);

    // A drag must not follow the product link underneath it.
    root.addEventListener('click', (e) => {
      if (!dragged) return;
      e.preventDefault();
      e.stopPropagation();
      dragged = false;
    }, true);

    // Stop the browser starting a native image drag when dragging with a mouse.
    root.addEventListener('dragstart', (e) => e.preventDefault());
  }

  getUpsellProductElement(element, product, productId) {
    const ids = [product && product.id, productId].filter(Boolean);
    return ids.reduce((found, id) => {
      return found || element.querySelector(`.fs-upsell-cross-sell-product[data-id="${id}"]`);
    }, null);
  }

  updatePDPWidgetTitle(element) {
    if (!document.body.classList.contains('template--product') || !element) return;
    if (!this.isPdpUpsellWidget(element)) return;

    const title = window.pdp_recommendations_title || 'Curated For You';
    const root = (typeof element.closest === 'function' && element.closest('.widget-main')) || element;
    const target = root.querySelector('.fs-recommendation-widget-title');
    if (!target || target.innerText.toLowerCase().includes(title.toLowerCase())) return;

    target.innerText = title;
  }

  formatUpsellReviews(product, productElement) {
    const container = productElement.querySelector('.fs-recommendation-product-review-container');
    if (!container) return;

    const raw = container.innerText.replace(/\s+/g, ' ').trim();
    const match = raw.match(/(\d+(?:\.\d+)?)\D+?(\d+)/);
    if (!match) return;

    const next = `(${match[1]}) ${match[2]} reviews`;
    let label = container.querySelector('.fs-pdp-reviews-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'fs-pdp-reviews-label';
      container.appendChild(label);
    }
    if (label.innerText === next) return;

    container.querySelectorAll('.fs-reviews-avg, .fs-reviews-count, .reviews-avg, .reviews-count, .rating').forEach((node) => {
      node.style.display = 'none';
    });
    label.innerText = next;
  }

  toUpsellAmount(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    const amount = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(amount) ? amount : null;
  }

  formatUpsellMoney(value) {
    const amount = this.toUpsellAmount(value);
    return amount == null ? '' : `$${amount.toFixed(2)}`;
  }

  formatUpsellRange(min, max) {
    if (min == null) return '';
    if (max == null || max <= 0 || max <= min + 0.001) return this.formatUpsellMoney(min);
    return `${this.formatUpsellMoney(min)} - ${this.formatUpsellMoney(max)}`;
  }

  /**
   * Returns the first value that resolves to a real, positive amount.
   * Fast Simon sends 0 for unset product level price fields, so a plain `??` chain
   * would accept that 0 as a valid amount and render ranges such as `$170.00 - $0.00`.
   *
   * @param {...*} values - Candidate values, in priority order.
   * @return {?number} The first positive amount, or null when there is none.
   */
  firstUpsellAmount(...values) {
    return values.reduce((found, value) => {
      if (found != null) return found;
      const amount = this.toUpsellAmount(value);
      return amount != null && amount > 0 ? amount : null;
    }, null);
  }

  getUpsellVariantList(product) {
    if (Array.isArray(product.variants)) return product.variants.filter(Boolean);
    if (product.variants && typeof product.variants === 'object') {
      return Object.values(product.variants).filter(Boolean);
    }
    return [];
  }

  getUpsellPriceRange(product) {
    const variants = this.getUpsellVariantList(product).map((variant) => ({
      price: this.toUpsellAmount(variant && (variant.p ?? variant.price)),
      compare: this.toUpsellAmount(variant && (variant.c ?? variant.compare ?? variant.comparePrice ?? variant.compare_at_price))
    })).filter((variant) => variant.price != null && variant.price > 0);

    const prices = variants.map((variant) => variant.price);
    const compares = variants.map((variant) => variant.compare).filter((amount) => amount != null && amount > 0);

    const min = prices.length ? Math.min(...prices) : this.firstUpsellAmount(product.p_min, product.p, product.price);
    const max = prices.length ? Math.max(...prices) : (this.firstUpsellAmount(product.p_max) ?? min);

    const compareMin = compares.length ? Math.min(...compares) : this.firstUpsellAmount(product.p_min_c, product.comparePrice);
    const compareMax = compares.length ? Math.max(...compares) : (this.firstUpsellAmount(product.p_max_c, product.maxCompare) ?? compareMin);
    const onSale = variants.some((variant) => variant.compare > variant.price) ||
      (compareMin != null && min != null && compareMin > min);

    return { min, max, compareMin, compareMax, onSale };
  }

  bindUpsellCardPrice(productElement) {
    if (!productElement || productElement.dataset.fsPriceBound === 'true') return;
    productElement.dataset.fsPriceBound = 'true';

    const select = productElement.querySelector('.size-select');
    if (select) {
      select.addEventListener('change', () => {
        productElement.dataset.fsPriceSelected = 'true';
        if (productElement.dataset.fsHydrated !== 'true') {
          delete productElement.dataset.fsHydrating;
          this.hydrateUpsellCardVariants(null, productElement);
        }
        this.updateUpsellSelectedPrice(productElement);
        this.syncUpsellAvailability(productElement);
      });
    }

    productElement.addEventListener('click', (e) => {
      const container = e.target.closest('.color-swatch-container');
      const swatch = e.target.closest('.color-swatch') ||
        (container && container.querySelector('.color-swatch'));
      if (!swatch) return;
      productElement.dataset.fsPriceSelected = 'true';
      requestAnimationFrame(() => {
        productElement.querySelectorAll('.color-swatch.selected').forEach((item) => {
          item.classList.remove('selected');
        });
        productElement.querySelectorAll('.color-swatch-container.selected').forEach((item) => {
          item.classList.remove('selected');
        });
        swatch.classList.add('selected');
        if (container) container.classList.add('selected');
        this.updateUpsellSelectedPrice(productElement);
        this.syncUpsellAvailability(productElement);
      });
    }, true);
  }

  updateUpsellSelectedPrice(productElement) {
    const match = this.findUpsellSelectedVariant(productElement);
    if (!match || match.price == null) return;
    this.writeUpsellCardPrice(productElement, match.price, match.compare);
  }

  writeUpsellCardPrice(productElement, price, compare) {
    const priceNode = productElement.querySelector('.fs-recommendation-product-price');
    if (priceNode) priceNode.innerText = this.formatUpsellMoney(price);

    const holder = productElement.querySelector('.fs-pdp-price-holder');
    let compareNode = this.findUpsellCompareNode(productElement);
    const showCompare = compare != null && compare > price;

    if (showCompare) {
      if (!compareNode && holder) {
        compareNode = document.createElement('span');
        compareNode.className = 'compare-price';
        holder.appendChild(compareNode);
      }
      if (compareNode) {
        const target = compareNode.querySelector('.compare-price, .fs-recommendation-compare-price, s, del') || compareNode;
        target.innerText = this.formatUpsellMoney(compare);
        compareNode.style.display = '';
      }
      if (holder) holder.classList.add('has-compare');
      return;
    }

    if (compareNode) compareNode.style.display = 'none';
    if (holder) holder.classList.remove('has-compare');
  }

  toShopifyHandle(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  getUpsellProductHandle(product, productElement) {
    const stored = productElement && (productElement.dataset.fsProductHandle || productElement.dataset.fsProductUrl);
    const fromLink = productElement && productElement.querySelector('[href*="/products/"]');
    const fromTitle = productElement && (
      (productElement.querySelector('.fs-recommendation-product-name-wrapper') || {}).textContent ||
      (productElement.querySelector('.fs-recommendation-product-title') || {}).getAttribute('aria-label') ||
      (productElement.querySelector('.fs-recommendation-product-title') || {}).textContent
    );
    const raw = (product && (product.productURL || product.u || product.url || product.l || product.handle || product.h)) ||
      stored ||
      (fromLink && fromLink.getAttribute('href')) ||
      '';

    if (raw) {
      const match = String(raw).match(/\/products\/([^/?#]+)/);
      if (match) return decodeURIComponent(match[1]);
      if (!String(raw).includes('/') && raw.length) return this.toShopifyHandle(raw);
    }

    return this.toShopifyHandle(fromTitle);
  }

  fetchUpsellProductData(handle) {
    if (!handle) return Promise.resolve(null);
    window.fsCardProductData = window.fsCardProductData || {};
    if (window.fsCardProductData[handle]) return Promise.resolve(window.fsCardProductData[handle]);

    const pendingKey = `${handle}:pending`;
    if (window.fsCardProductData[pendingKey]) return window.fsCardProductData[pendingKey];

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const pending = fetch(`${root}products/${handle}.js`)
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        if (data) window.fsCardProductData[handle] = data;
        delete window.fsCardProductData[pendingKey];
        return data;
      })
      .catch(() => {
        delete window.fsCardProductData[pendingKey];
        return null;
      });

    window.fsCardProductData[pendingKey] = pending;
    return pending;
  }

  readUpsellCardVariants(productElement) {
    try {
      const raw = productElement.dataset.fsVariants ||
        ((productElement.querySelector('.add-to-cart-button-wrapper') || {}).dataset.variants);
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      return [];
    }
  }

  writeUpsellCardVariants(productElement, variants) {
    const json = JSON.stringify(variants);
    productElement.dataset.fsVariants = json;
    const wrapper = productElement.querySelector('.add-to-cart-button-wrapper');
    if (wrapper) wrapper.dataset.variants = json;
  }

  shopifyCentsToAmount(value) {
    const amount = this.toUpsellAmount(value);
    return amount == null ? null : amount / 100;
  }

  hydrateUpsellCardVariants(product, productElement) {
    if (!productElement || productElement.dataset.fsHydrated === 'true') return;
    if (productElement.dataset.fsHydrating === 'true' && !productElement.dataset.fsProductHandle) {
      delete productElement.dataset.fsHydrating;
    }
    if (productElement.dataset.fsHydrating === 'true') return;

    const handle = this.getUpsellProductHandle(product, productElement);
    if (!handle) return;

    productElement.dataset.fsProductHandle = handle;
    productElement.dataset.fsHydrating = 'true';

    this.fetchUpsellProductData(handle).then((data) => {
      if (!data || !Array.isArray(data.variants)) {
        delete productElement.dataset.fsHydrating;
        return;
      }
      this.mergeUpsellShopifyVariants(productElement, data);
      this.preselectUpsellAvailableVariant(productElement);
      productElement.dataset.fsHydrated = 'true';
      productElement.dataset.fsPriceSelected = 'true';
      this.updateUpsellSelectedPrice(productElement);
      this.syncUpsellAvailability(productElement);
      this.addUpsellExtraColorsLabel(null, productElement, data);
    });
  }

  mergeUpsellShopifyVariants(productElement, data) {
    const shopById = {};
    data.variants.forEach((variant) => {
      shopById[Number(variant.id)] = variant;
    });

    const giftId = window.gwpGiftVariantId;
    const shopMatch = (variant) => {
      const byId = shopById[Number(variant.id)];
      if (byId) return byId;
      const size = String(variant.size || '').toLowerCase();
      const color = this.toUpsellColorHandle(variant.color);
      return data.variants.find((shop) => {
        const options = [shop.option1, shop.option2, shop.option3].filter(Boolean).map((option) => String(option).toLowerCase());
        return options.includes(size) && options.map((option) => this.toUpsellColorHandle(option)).includes(color);
      });
    };

    const variants = this.readUpsellCardVariants(productElement).map((variant) => {
      const shop = shopMatch(variant);
      if (!shop) return variant;
      return {
        ...variant,
        price: this.shopifyCentsToAmount(shop.price),
        compare: shop.compare_at_price ? this.shopifyCentsToAmount(shop.compare_at_price) : null,
        available: shop.available === true && Number(variant.id) !== Number(giftId)
      };
    });

    this.writeUpsellCardVariants(productElement, variants);
  }

  getUpsellSwatchColor(swatch) {
    if (!swatch) return '';
    const fromTitle = swatch.getAttribute('title');
    if (fromTitle) return this.toUpsellColorHandle(fromTitle);
    const nameEl = swatch.parentElement && swatch.parentElement.querySelector('.fs-color-name, .color-swatch-color-name');
    if (nameEl && nameEl.textContent) return this.toUpsellColorHandle(nameEl.textContent);
    const fromClass = (String(swatch.className).match(/fast-swatch-color-([a-z0-9_-]+)/g) || [])
      .map((name) => name.replace('fast-swatch-color-', ''))
      .find((name) => name !== 'fallback' && name !== 'gray' && name !== 'light' && name !== 'dark');
    return this.toUpsellColorHandle(fromClass);
  }

  selectUpsellSwatch(productElement, color) {
    const handle = this.toUpsellColorHandle(color);
    if (!handle) return;
    productElement.querySelectorAll('.color-swatch').forEach((swatch) => {
      swatch.classList.toggle('selected', this.getUpsellSwatchColor(swatch) === handle);
    });
  }

  preselectUpsellAvailableVariant(productElement) {
    const variants = this.readUpsellCardVariants(productElement);
    const first = variants.find((variant) => variant.available) || variants[0];
    if (!first) return;

    const select = productElement.querySelector('.size-select');
    if (select && first.size) select.value = first.size;
    this.selectUpsellSwatch(productElement, first.color);
  }

  findUpsellSelectedVariant(productElement) {
    const variants = this.readUpsellCardVariants(productElement);
    const select = productElement.querySelector('.size-select');
    const size = select && select.value;
    const color = this.getUpsellSelectedColor(
      productElement.querySelector('.add-to-cart-button') || productElement
    );

    let match = color && size
      ? variants.find((variant) => variant.size === size && this.toUpsellColorHandle(variant.color) === color)
      : null;
    if (!color && size) match = variants.find((variant) => variant.size === size);
    return match || null;
  }

  syncUpsellAvailability(productElement) {
    const variants = this.readUpsellCardVariants(productElement);
    if (!variants.length || !variants.some((variant) => variant.available != null)) return;

    const select = productElement.querySelector('.size-select');
    const size = select && select.value;

    productElement.querySelectorAll('.color-swatch').forEach((swatch) => {
      const color = this.getUpsellSwatchColor(swatch);
      const isAvailable = variants.some((variant) => (
        variant.available &&
        (!size || variant.size === size) &&
        this.toUpsellColorHandle(variant.color) === color
      ));
      swatch.setAttribute('data-disabled', 'false');
      swatch.setAttribute('aria-disabled', 'false');
      swatch.classList.toggle('variant--unavailable', !isAvailable);
      const container = swatch.closest('.color-swatch-container');
      if (container) {
        container.setAttribute('aria-disabled', 'false');
        container.classList.toggle('variant--unavailable', !isAvailable);
      }
    });

    if (select) {
      Array.from(select.options).forEach((option) => {
        option.disabled = false;
        option.removeAttribute('disabled');
        option.setAttribute('aria-disabled', 'false');
      });
    }

    const match = this.findUpsellSelectedVariant(productElement);
    const unavailable = !match || match.available === false;
    const atc = productElement.querySelector('.add-to-cart-button');
    if (atc) atc.disabled = unavailable;

    const buttonWrapper = productElement.querySelector('.add-to-cart-button-wrapper');
    if (!buttonWrapper) return;

    let message = productElement.querySelector('.fs-pdp-stock-message');
    if (!message) {
      message = document.createElement('small');
      message.className = 'fs-pdp-stock-message';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      buttonWrapper.insertAdjacentElement('afterend', message);
    }
    message.innerText = (window.variantStrings && window.variantStrings.soldOut) || 'Out of stock';
    message.hidden = !unavailable;
  }

  applyUpsellPriceRange(product, productElement) {
    const range = this.getUpsellPriceRange(product);
    if (range.min == null) return;

    const priceNode = productElement.querySelector('.fs-recommendation-product-price');
    const priceText = this.formatUpsellRange(range.min, range.max);
    if (priceNode && priceNode.innerText.trim() !== priceText) {
      priceNode.innerText = priceText;
    }

    if (!range.onSale) return;

    const compareNode = this.findUpsellCompareNode(productElement);
    if (!compareNode) return;

    const compareText = this.formatUpsellRange(range.compareMin, range.compareMax);
    const target = compareNode.querySelector('.compare-price, .fs-recommendation-compare-price, s, del') || compareNode;
    if (compareText && target.innerText.trim() !== compareText) {
      target.innerText = compareText;
    }
  }

  findUpsellPriceNode(productElement) {
    const priceText = productElement.querySelector('.fs-recommendation-product-price');
    return productElement.querySelector('.fs-recommendation-price-container, .price-container') ||
      (priceText && (priceText.closest('.fs-recommendation-price-container, .price-container, .fs-recommendation-product-info > *') || priceText));
  }

  findUpsellCompareNode(productElement) {
    const direct = productElement.querySelector([
      '.fs-recommendation-compare-container',
      '.compare-container',
      '.fs-recommendation-compare-price',
      '.compare.fs-compare',
      '[class*="compare-container"]'
    ].join(', '));
    if (direct) return direct;

    return Array.from(productElement.querySelectorAll('s, del, [class*="compare"]')).find((node) => {
      return /\$\s*\d/.test(node.innerText || '');
    }) || null;
  }

  layoutUpsellCard(productElement) {
    const info = productElement.querySelector('.fs-recommendation-product-info') || productElement;
    const price = this.findUpsellPriceNode(productElement);
    const compare = this.findUpsellCompareNode(productElement);

    let holder = productElement.querySelector('.fs-pdp-price-holder');
    if (!holder && price) {
      holder = document.createElement('div');
      holder.classList.add('fs-pdp-price-holder');
    }

    if (holder && price && price.parentNode !== holder) {
      holder.appendChild(price);
    }
    if (holder && compare && compare.parentNode !== holder) {
      holder.appendChild(compare);
    }

    if (holder && this.hasUpsellComparePrice(productElement)) {
      holder.classList.add('has-compare');
    } else if (holder) {
      holder.classList.remove('has-compare');
    }

    const reviews = productElement.querySelector('.fs-recommendation-product-review-container');
    const title = productElement.querySelector('.fs-recommendation-product-title');
    const swatches = productElement.querySelector('.fs-serp-swatches');

    if (reviews) info.appendChild(reviews);
    if (title) info.appendChild(title);
    if (holder) info.appendChild(holder);
    if (swatches) info.appendChild(swatches);
  }

  hasUpsellComparePrice(productElement) {
    const priceNode = productElement.querySelector('.fs-recommendation-product-price');
    const compareNode = this.findUpsellCompareNode(productElement);
    if (!priceNode || !compareNode) return false;

    const price = this.toUpsellAmount(priceNode.innerText);
    const compareTarget = compareNode.querySelector(
      '.compare-price, .fs-recommendation-product-compare-price, s, del'
    ) || compareNode;
    const compare = this.toUpsellAmount(compareTarget.innerText);

    return price != null && compare != null && compare > price;
  }

  moveUpsellBadgesToImage(productElement) {
    const image = productElement.querySelector('.image-wrapper, .upsell-cross-sell-image-container');
    if (!image) return;

    const badges = productElement.querySelector('.fs-badges-wrapper');
    if (!badges) return;

    badges.classList.add('fs-pdp-badge-overlay');
    if (image.contains(badges)) return;

    badges.remove();
    image.appendChild(badges);
  }

  normalizeUpsellSwatches(product, productElement) {
    const root = productElement.querySelector('.fs-serp-swatches');
    if (!root) return;

    root.querySelectorAll('.color-swatch-color-name, .fs-color-name').forEach((el) => {
      el.style.display = 'none';
    });

    const hexByHandle = {
      white: '#ffffff',
      ivory: '#f0ede2',
      cream: '#f2efe6',
      pearl: '#f0ecda',
      bone: '#e3dac9',
      natural: '#f4f1e8',
      'deco-white': '#ffffff'
    };

    const toHandle = (name) => String(name || '').toLowerCase().replace(/\s/g, '-');
    const paint = (swatch, colorName) => {
      if (!swatch || !colorName) return;
      const handle = toHandle(colorName);
      const hex = hexByHandle[handle];
      swatch.classList.add('color-swatch', `fast-swatch-color-${handle}`);
      swatch.style.setProperty('--swatch-width', '27px');
      swatch.style.setProperty('--swatch-height', '27px');
      if (hex) swatch.style.backgroundColor = hex;
    };

    const colors = [...new Set(this.getUpsellVariantList(product).map((variant) => {
      return variant.attributes && variant.attributes.Color;
    }).filter(Boolean))];

    if (colors.length === 1) {
      let swatch = root.querySelector('.color-swatch');
      if (!swatch) {
        const list = root.querySelector('.color-swatches') || root;
        list.innerHTML = '';
        swatch = document.createElement('span');
        swatch.className = `color-swatch fast-swatch-color-fallback fast-swatch-color-${toHandle(colors[0])} selected`;
        swatch.setAttribute('title', colors[0]);
        swatch.setAttribute('data-disabled', 'false');
        list.appendChild(swatch);
      }
      paint(swatch, colors[0]);
    } else {
      root.querySelectorAll('.color-swatch').forEach((swatch) => {
        const fromTitle = swatch.getAttribute('title');
        const fromClass = (String(swatch.className).match(/fast-swatch-color-([a-z0-9_-]+)/) || [])[1];
        paint(swatch, fromTitle || fromClass);
      });
    }

    this.addUpsellExtraColorsLabel(product, productElement);
  }

  getUpsellColorNames(product, productElement, shopifyData) {
    const names = [];
    const add = (name) => {
      const value = String(name || '').trim();
      if (!value) return;
      const handle = this.toUpsellColorHandle(value);
      if (!names.some((item) => this.toUpsellColorHandle(item) === handle)) {
        names.push(value);
      }
    };

    const colorOption = shopifyData && Array.isArray(shopifyData.options)
      ? shopifyData.options.find((option) => /color|colour/i.test(option.name))
      : null;
    (colorOption && colorOption.values ? colorOption.values : []).forEach(add);

    this.getUpsellVariantList(product || {}).forEach((variant) => {
      add(variant.attributes && (variant.attributes.Color || variant.attributes.Colour));
      add(variant.color);
    });

    this.readUpsellCardVariants(productElement).forEach((variant) => add(variant.color));

    if (!names.length && productElement) {
      productElement.querySelectorAll('.color-swatch').forEach((swatch) => {
        add(swatch.getAttribute('title'));
      });
    }

    return names;
  }

  getUpsellProductHref(product, productElement) {
    const fromLink = productElement.querySelector('.title-container, .fs-recommendation-product-title a, a[href*="/products/"]');
    const raw = (product && (product.productURL || product.u || product.url)) ||
      productElement.dataset.fsProductUrl ||
      (fromLink && fromLink.getAttribute('href')) ||
      '';

    if (raw && String(raw).includes('/products/')) return String(raw).split('?')[0];

    const handle = this.getUpsellProductHandle(product, productElement);
    return handle ? `/products/${handle}` : '';
  }

  addUpsellExtraColorsLabel(product, productElement, shopifyData) {
    if (!productElement || !this.isPdpUpsellWidget(productElement)) return;

    const root = productElement.querySelector('.fs-serp-swatches');
    if (!root) return;

    const showMore = root.querySelector('.show-more-swatches');
    const colors = this.getUpsellColorNames(product, productElement, shopifyData);
    const visibleSwatches = [...root.querySelectorAll('.color-swatch')].filter((swatch) => {
      if (swatch.closest('.show-more-swatches')) return false;
      const style = window.getComputedStyle(swatch);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
    const extraColorsLength = colors.length > visibleSwatches.length
      ? colors.length - visibleSwatches.length
      : 0;

    if (extraColorsLength < 1) {
      if (showMore && colors.length && colors.length <= visibleSwatches.length) {
        showMore.style.display = 'none';
      }
      return;
    }

    const text = `+ ${extraColorsLength} ${extraColorsLength === 1 ? 'color' : 'colors'}`;
    const href = this.getUpsellProductHref(product, productElement);
    const list = root.querySelector('.color-swatches') || root;
    let colorsCountEl = root.querySelector('.color-swatch-extra-colors');

    if (!colorsCountEl) {
      colorsCountEl = document.createElement('a');
      colorsCountEl.classList.add('color-swatch-extra-colors');
      list.appendChild(colorsCountEl);
    }

    colorsCountEl.innerText = text;
    colorsCountEl.setAttribute('href', href || '#');
    colorsCountEl.setAttribute('tabindex', '0');
    colorsCountEl.setAttribute('role', 'button');
    colorsCountEl.setAttribute('aria-label', text);

    if (showMore) showMore.style.display = 'none';
  }

  /**
   * Adds a variant selector to an upsell card for a given product. The method dynamically
   * generates a size dropdown based on product variant sizes, appends it to the target DOM element,
   * and updates the add-to-cart button functionality.
   *
   * @param {Object} product - The product object containing variant information such as sizes, colors, and IDs.
   * @param {HTMLElement} target - The DOM element representing the upsell card where the variant select will be added.
   * @return {void} This method does not return a value.
   */
  addVariantSelectToUpsellCard(product, target) {
    const variantList = this.getUpsellVariantList(product);
    if (!variantList.length) return;

    let sizes = [...new Set(variantList.map((variant) => {
      return variant.attributes && variant.attributes.Size;
    }).filter(Boolean))];
    let variants = variantList.map((variant) => ({
      size: variant.attributes && variant.attributes.Size,
      color: variant.attributes && variant.attributes.Color,
      id: variant.id,
      price: this.toUpsellAmount(variant.p ?? variant.price),
      compare: this.toUpsellAmount(variant.c ?? variant.compare ?? variant.comparePrice ?? variant.compare_at_price)
    }));

    target.dataset.variants = JSON.stringify(variants);
    const card = target.closest('.fs-upsell-cross-sell-product, .fs-recommendation-product-container');
    if (card) card.dataset.fsVariants = target.dataset.variants;

    let dropdown = document.createElement('select');
    dropdown.classList.add('size-select');

    sizes.forEach(size => {
      let option = document.createElement('option');
      option.text = size;
      option.value = size;
      dropdown.appendChild(option);
    });

    target.appendChild(dropdown);

    if (target.querySelector('.add-to-cart-button')) {

      let atcButton = target.querySelector('.add-to-cart-button');

      //remove event listeners
      var newAtcButton = atcButton.cloneNode(true);
      newAtcButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>';
      atcButton.parentNode.replaceChild(newAtcButton, atcButton);

      newAtcButton.addEventListener('click', (e) => this.handleUpsellATCClick(e));
    }
  }

  /**
   * Removes the 'active' class from all elements with the class 'monogram-inner-container'
   * within the provided element.
   *
   * @param {HTMLElement} element - The parent HTML element containing the tooltips to be cleared.
   * @return {void} This method does not return a value.
   */
  clearTooltips(element) {
    element.querySelectorAll('.monogram-inner-container.active').forEach(tooltip => {
      tooltip.classList.remove('active');
    });
  }

  /**
   * Updates the price and compare price elements within a product element, optionally adding tier-based pricing or retail displays.
   * This method dynamically modifies DOM elements to reflect new pricing structures, including trade and retail tiers.
   *
   * @param {HTMLElement} productElement - The root HTML element for the product where prices should be updated.
   * @param {number} lowestPrice - The lowest price value for the product.
   * @param {number} highestPrice - The highest price value for the product, may be null or 0.
   * @param {number} lowestCompare - The lowest compare price value for the product, used to display original/retail pricing.
   * @param {number} highestCompare - The highest compare price value for the product, may be null or 0.
   * @param {string} pId - The unique identifier for the product.
   * @param {string|null} [tiername=null] - The name of the pricing tier to display, such as trade pricing. Defaults to null.
   * @return {void} This method does not return any value; it directly updates the DOM elements.
   */
  setNewPrice(productElement, lowestPrice, highestPrice, lowestCompare, highestCompare, pId, tiername = null) {
    const priceElement = productElement.querySelector('.price, .fs-price');
    const compareElement = productElement.querySelector('.compare, .fs-price.compare');
    const basePrice = productElement.querySelector('.price');

    // --- Hide compare element if it exists ---
    if (compareElement) {
      compareElement.style.display = 'none';
    }

    const highestPriceString = highestPrice && highestPrice > 0 && highestPrice != lowestPrice ? ` - $${highestPrice}` : '';
    const highestCompareString = highestCompare && highestCompare > 0 && highestCompare != lowestCompare ? ` - $${highestCompare}` : '';

    // --- Add Trade price only if it doesn't already exist ---
    if (tiername && lowestPrice && priceElement && !productElement.querySelector('.trade.price')) {
      // Capitalize tiername (first letter uppercase, rest lowercase)
      const tierDisplay =
        tiername && typeof tiername === 'string'
          ? tiername.charAt(0).toUpperCase() + tiername.slice(1).toLowerCase()
          : '';

      const tradeHtml = `
      <div class="trade price">
        <span>
          $${lowestPrice}${highestPriceString}
          <span style="letter-spacing:0; font-size:11px; vertical-align:unset;">${tierDisplay}</span>
        </span>
      </div>`;

      priceElement.insertAdjacentHTML('afterend', tradeHtml);
    }

    // --- Add Retail compare only if it doesn't already exist ---
    if (lowestCompare && !productElement.querySelector('.retail.compare')) {
      basePrice.parentNode.classList.add('has-compare');

      const retailHtml = `
      <div class="retail compare">
        <span>
          $${lowestCompare}${highestCompareString}
          <span class="${tiername ? '' : 'hidden'}" style="letter-spacing:0; font-size:11px; vertical-align:unset;">Retail</span>
        </span>
      </div>`;
      // Insert after hidden compare element if it existed
      if (compareElement) {
        compareElement.insertAdjacentHTML('afterend', retailHtml);
      } else if (priceElement) {
        priceElement.insertAdjacentHTML('afterend', retailHtml);
      }
    }

    // --- Modify base price ---
    if (basePrice) {

      let b2bMultiplier = 1;
      if (typeof window.b2bMultiplier != 'undefined') {
        b2bMultiplier = parseFloat(window.b2bMultiplier);
        basePrice.closest('.price-holder').classList.add('has-b2b-pricing');
      }

      let b2bPrice = (lowestPrice * b2bMultiplier).toFixed(2);
      let b2bPriceString = `$${b2bPrice}`;
      if (highestPrice > 0) {
        let highestB2bPrice = (highestPrice * b2bMultiplier).toFixed(2);
        b2bPriceString += highestB2bPrice > 0 && highestB2bPrice != b2bPrice ? ` - $${highestB2bPrice}` : '';
      }

      basePrice.innerHTML = `${b2bPriceString}`;

      // --- Add "Retail" label inside main price (only once) ---
      if (!basePrice.querySelector('.inline-retail')) {
        basePrice.insertAdjacentHTML(
          'beforeend',
          `<span class="${tiername ? '' : 'hidden '}inline-retail" style="letter-spacing:0; font-size:11px; vertical-align:unset; margin-left:4px;">Retail</span>`
        );
      }
      basePrice.classList.add('retail');
    }
  }

  /**
   * Updates a product element's price display using special pricing obtained from JSON data fetched based on the product URL.
   *
   * @param {HTMLElement} productElement - The DOM element representing the product where the special price will be displayed.
   * @param {string|number} pId - The unique product identifier to reference the product data in the `window.pdpData` object.
   * @param {string} productURL - The URL used to fetch the product's JSON data containing pricing details.
   * @param {string|null} [tiername=null] - An optional parameter used to handle pricing tiers (if applicable).
   * @return {void} Does not return a value. Modifies the `productElement` directly or hides it if an error occurs.
   */
  async setProductSpecialPrice(productElement, pId, productURL, tiername = null) {
    let _this = this;
    const country = Shopify?.country;
    if (!productURL || !productElement) return;

    const splattedURL = productURL.split('?');

    try {
      if (window.pdpData[pId] && window.pdpData[pId] === "notFetched") {
        const fullURL = `${splattedURL[0]}.json${splattedURL?.[1] ? `?${splattedURL[1]}` : ''}`;

        const res = await fetch(fullURL, { cache: 'no-store' });
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        // Read as text first to handle empty/invalid JSON safely
        const text = await res.text();
        if (!text) {
          throw new Error('Empty response body');
        }

        let data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          throw new Error('Invalid JSON in response');
        }

        if (!data?.product) throw new Error('Missing product field');
        window.pdpData[pId] = data.product;
      }

      if (window.pdpData[pId] && window.pdpData[pId] !== "notFetched" && window.pdpData[pId] !== "404") {
        const product = window.pdpData[pId];

        const variantID = productURL
          .split('&')
          .find(param => param.includes('variant'))
          ?.split('=')?.[1];

        let lowestPriceVariant = product.variants.reduce((min, v) => parseFloat(v.price) < parseFloat(min.price) ? v : min, product.variants[0]);
        let highestPriceVariant = product.variants.reduce((max, v) => parseFloat(v.price) > parseFloat(max.price) ? v : max, product.variants[0]);

        const variant = product.variants.find(v => v.id === Number(variantID)) ||
          lowestPriceVariant;

        if (variant) {
          const lowestPrice = lowestPriceVariant?.price ?? 0;
          const highestPrice = highestPriceVariant?.price ?? 0;
          const lowestCompare = parseFloat(lowestPriceVariant?.compare_at_price) > 0.0 ? lowestPriceVariant?.compare_at_price : null;
          let highestCompare = parseFloat(highestPriceVariant?.compare_at_price) > 0.0 ? highestPriceVariant?.compare_at_price : null;

          if (!highestCompare && lowestCompare && highestPrice > 0) {
            highestCompare = highestPrice;
          }

          _this.setNewPrice(productElement, lowestPrice, highestPrice, lowestCompare, highestCompare, pId, tiername);
        }
      }
    } catch (err) {
      //console.error('setProductSpecialPrice error:', err);
      // Hide the product tile when JSON fetch/parse fails
      productElement.style.display = 'none';
      // Optional: mark as failed so we don't retry endlessly on this render
      window.pdpData[pId] = err.message.includes('404') ? '404' : "notFetched";
      return;
    }
  }

  /**
   * Adds a sale tag to a product's element, fetching the tag data asynchronously and ensuring it is updated in the DOM.
   *
   * @param {Object} product - The product object containing details such as the product URL.
   * @param {string} productId - The unique identifier of the product.
   * @param {HTMLElement} productElement - The HTML element representing the product in the DOM.
   * @return {void} This method does not return a value.
   */
  addSaleTag(product, productId, productElement) {
    let _this = this;
    // Sale Tag

    if (window.pdpData[productId] == '404') return;

    // Add holder for after color swatches if not exists
    if (!productElement.querySelector('.after-color-swatches-wrapper')) {
      let elementHolder = document.createElement("div");
      elementHolder.classList.add('after-color-swatches-wrapper');

      let infoContainer = productElement.querySelector('.info-container');
      if (infoContainer) {
        infoContainer.appendChild(elementHolder);
      }
    }

    // Remove existing sale-tag-fetched class to allow re-fetching if needed
    if (productElement.classList.contains('sale-tag-fetched')) {
      productElement.classList.remove('sale-tag-fetched');

      // clear window.fetchingSaleTag
      _this.fetchingSaleTag[productId] = false;
    }

    // Fetch URL
    let fetchUrl = product.productURL + '?view=product_data';

    // Ensure global tracker exists
    _this.fetchingSaleTag = _this.fetchingSaleTag || {};

    // Only run if not fetched or fetching yet
    if (
      product.productURL &&
      !productElement.classList.contains('sale-tag-fetched') &&
      !_this.fetchingSaleTag[productId]
    ) {
      // Mark as fetching immediately to prevent duplicates
      _this.fetchingSaleTag[productId] = true;

      fetch(fetchUrl)
        .then(response => response.json())
        .then(data => {
          // Mark as fetched (only once)
          productElement.classList.add('sale-tag-fetched');

          if (data.sale_tag) {
            // Decode and append HTML safely
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.sale_tag;
            let decodedHTML = tempDiv.textContent || tempDiv.innerText;

            if (decodedHTML) {
              let infoContainer = productElement.querySelector('.after-color-swatches-wrapper');
              if (infoContainer) {
                infoContainer.innerHTML = decodedHTML;
              }
            }
          }
        })
        .catch(error => {
          console.error('Error fetching product data:', error);
        })
        .finally(() => {
          // Mark as complete (optional cleanup)
          _this.fetchingSaleTag[productId] = false;
        });
    }
  }

}

let fsCustom = new FSCustom();
fsCustom.init();
